export const resetMaskSelector = () => ({
  type: "RESET_MASK_SELECTOR"
});

export const setMaskSelector = maskSelector => ({
  type: "SET_MASK_SELECTOR",
  maskSelector
});



// WEBPACK FOOTER //
// ./src/actions/actions/mask-selector.js